/**
 * Component utils index file
 * Exports all component-specific utility functions from the utils directory
 */

// Import and export component utility functions
// These will be implemented in future iterations

/**
 * Format a component display name
 * @param {string} name - The name to format
 * @returns {string} The formatted name
 */
export const formatComponentName = (name) => {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1);
};

/**
 * Generate a unique component ID
 * @returns {string} A unique ID
 */
export const generateComponentId = () => {
  return `component-${Math.random().toString(36).substring(2, 15)}`;
};

// Export default
export default {
  formatComponentName,
  generateComponentId
};
